import { createStructuredSelector } from 'reselect';
import {
  tokenSelector,
  officeSelector,
  clientConfigSelector,
  userSelector,
  importStatusSelector
} from '../../selectors/global';

export default createStructuredSelector({
  office: officeSelector,
  token: tokenSelector,
  config: clientConfigSelector,
  user: userSelector,
  importStatus: importStatusSelector
});
